// extracted by mini-css-extract-plugin
module.exports = {"badges":"style_badges__2nkUc","badge":"style_badge__1ninL","addBox":"style_addBox__3UEw7","delete":"style_delete__2yvBm"};